<div class="layout-sidebar" [ngClass]="{ 'layout-sidebar-active': app.sidebarActive }" (click)="app.onSidebarClick($event)" (mouseover)="app.sidebarActive = true" (mouseleave)="app.sidebarActive = false">
  <div class="sidebar-logo">
    <a class="sidebar-pin" title="Toggle Menu" (click)="toggleMenu()">
      <i class="pi pi-lock" *ngIf="settingsService.MenuIsStatic"></i>
      <i class="pi pi-lock-open" *ngIf="!settingsService.MenuIsStatic"></i>
    </a>
    <a class="sidebar-pin" title="Aide" (click)="toggleAide()">
      <i class="fa fa-question" *ngIf="!aideService.displayEditAide || !isAdminAide()" style="font-size: 20px" [ngClass]="{ 'text-danger': aideService.displayAide }"></i>
      <i class="fa fa-pencil" aria-hidden="true" *ngIf="aideService.displayEditAide && isAdminAide()" style="font-size: 20px" [ngClass]="{ 'text-danger': aideService.displayAide }"></i>
    </a>

    <a routerLink="/">
      <img alt="logo" src="assets/performance.png" />
      <span class="app-name">Indicateurs de performance</span>
    </a>

    <a class="sidebar-pin sidebar-pin-retracted" title="Aide" (click)="toggleAide()">
      <i class="fa fa-question" *ngIf="!aideService.displayEditAide || !isAdminAide()" style="font-size: 20px" [ngClass]="{ 'text-danger': aideService.displayAide }"></i>
      <i class="fa fa-pencil" aria-hidden="true" *ngIf="aideService.displayEditAide && isAdminAide()" style="font-size: 20px" [ngClass]="{ 'text-danger': aideService.displayAide }"></i>
    </a>
  </div>

  <div class="layout-menu-container" (click)="onMenuClick()">
    <ul class="layout-menu">
      <ng-container *ngFor="let item of model; let i = index">
        <li app-menuitem [item]="item" [index]="i" [root]="true" *ngIf="!item.visibleFunction || item.visibleFunction()"></li>
      </ng-container>
      <display-type-media [typeMediaId]="configurationService.typesMedia.aide" label="Tutoriel" [displayTooltip]="false" *ngIf="isAuthentificated"></display-type-media>
    </ul>
  </div>
</div>
